export default __webpack_public_path__ + "staticlp1/media/logo-header-white.f32360d7.png";